import React from "react";
import { Box, Paper, Typography, Button, Stack, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  MdDateRange,
  MdAddShoppingCart,
  MdBadge,
  MdAccountBalanceWallet,
  MdChecklist,
  MdTune,
} from "react-icons/md";

const QuickShortcutsBar = ({
  userRole,
  hasPermission,
  isFeatureEnabled = () => true,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isDark = theme.palette.mode === "dark";
  const isEmployeeRole = userRole?.toLowerCase() === "employee";

  const actions = [
    {
      title: "Apply Leave",
      icon: MdDateRange,
      iconColor: "#4f46e5",
      path: isEmployeeRole ? "/company/apply-leave" : "/company/leave-details",
      show: isFeatureEnabled("leave") && !isEmployeeRole,
    },
    {
      title: "Create Requisition",
      icon: MdAddShoppingCart,
      iconColor: "#7c3aed",
      path: "/company/requisition-create",
      show: isFeatureEnabled("employees") && !isEmployeeRole,
    },
    {
      title: "Staff Directory",
      icon: MdBadge,
      iconColor: "#0284c7",
      path: "/company/employee",
      show:
        isFeatureEnabled("employees") &&
        (hasPermission("employee.view") || !isEmployeeRole),
    },
    {
      title: "Process Payroll",
      icon: MdAccountBalanceWallet,
      iconColor: "#475569",
      path: "/company/process-payroll",
      show:
        isFeatureEnabled("payroll") &&
        (hasPermission("process_payroll.view") || !isEmployeeRole),
    },
    {
      title: "Project Tasks",
      icon: MdChecklist,
      iconColor: "#2563eb",
      path: "/company/tasks",
      show:
        isFeatureEnabled("projects") &&
        (hasPermission("task.view") || hasPermission("projects.view")) &&
        !isEmployeeRole,
    },
  ];

  const visibleActions = actions.filter((a) => a.show);

  if (visibleActions.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        // p: { xs: 1.5, sm: 1.75 },
        mb: 3,
        borderRadius: "8px",
        bgcolor: "transparent",
        // border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0"}`,
        // boxShadow: isDark
        //   ? "0 1px 3px rgba(0,0,0,0.4)"
        //   : "0 1px 3px rgba(15,23,42,0.03)",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
        }}
      >
        {/* Left Side: Label + Buttons */}
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          flexWrap="wrap"
          sx={{ gap: 1.25, flex: 1, minWidth: 0 }}
        >
          {/* <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              fontSize: "0.72rem",
              letterSpacing: "0.08em",
              color: "text.secondary",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              pr: 0.5,
            }}
          >
            Quick Dispatch
          </Typography> */}

          {visibleActions.map((action) => {
            const Icon = action.icon;
            return (
              <Button
                key={action.title}
                onClick={() => navigate(action.path)}
                startIcon={<Icon size={16} color={action.iconColor} />}
                sx={{
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.82rem",
                  py: 0.65,
                  px: 1.6,
                  bgcolor: isDark ? "rgba(59, 130, 246, 0.12)" : "#eff6ff",
                  border: `1px solid ${
                    isDark ? "rgba(59, 130, 246, 0.25)" : "#dbeafe"
                  }`,
                  color: isDark ? "#f1f5f9" : "#1e293b",
                  boxShadow: "none",
                  transition: "all 0.15s ease",
                  "&:hover": {
                    bgcolor: isDark ? "rgba(59, 130, 246, 0.2)" : "#dbeafe",
                    borderColor: isDark ? "rgba(59, 130, 246, 0.4)" : "#bfdbfe",
                    boxShadow: "none",
                  },
                }}
              >
                {action.title}
              </Button>
            );
          })}
        </Stack>

        {/* Right Side: Configured indicator */}
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          sx={{
            color: "text.secondary",
            opacity: 0.75,
            display: { xs: "none", md: "flex" },
            flexShrink: 0,
          }}
        >
          {/* <Typography variant="caption" sx={{ fontSize: "0.72rem", fontWeight: 500 }}>
            Custom shortcuts configured
          </Typography>
          <MdTune size={14} /> */}
        </Stack>
      </Box>
    </Paper>
  );
};

export default QuickShortcutsBar;
